<template>
  <div class="bg-gray-21 p-3">
    <div class="d-flex justify-content-end">
      <action-button
        class="outline-success px-4 py-2 mr-2"
        text="Ver Solicitudes Activas"
        i="fa fa-eye"
        @click="$router.push('email-dashboard')"
      />
      <action-button
        class="btn-warning-outline px-4 py-2 mr-2"
        :text="$t('GoBack')"
        i="fa fa-arrow-circle-left"
        @click="$router.go(-1)"
      />
    </div>

    <div class="admin-user-profile-view card mt-4">
      <div class="card-body p-5">
        <div class="row">
          <h3 style="align-items: center">
            Solicitudes ocultas con mas de 6 meses aprobadas
          </h3>

          <!-- <div class="col-2 mt-4" style="float: right;">
            <action-button
              class="btn-warning px-4 py-2"
              text="Enviar"
              i="fa fa-envelope"
              @click="onSearch"
            />
          </div> -->
        </div>
        <div class="row">
          <div class="col-12">
            <separator-extended text="Resultados" />
            <custom-result-not-found v-if="emptyResults" />

            <div
              v-for="(item, index) in results.data"
              :key="`result-item-${index}`"
              class="mx-3"
            >
              <div class="row bg-gray rounded p-3 mb-2">
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Solicitud:
                  </div>

                  <div class="color-black font-16">
                    <a :href="'/request/' + item.businessId">
                      {{ item.businessId }}
                    </a>
                  </div>
                </div>
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Nombre del Usuario:
                  </div>

                  <div class="color-black font-16">{{ item.requester }}</div>
                </div>
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Email:
                  </div>
                  <div class="color-black font-16">
                    {{ item.email }}
                  </div>
                </div>
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Fecha Autorización:
                  </div>
                  <div class="color-black font-16 font-weight-bold">
                    {{ item.updatedDate }}
                  </div>
                </div>
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Cant. Email Enviados:
                  </div>
                  <div class="color-black font-16 font-weight-bold">
                    {{ item.reminderQuantity }}
                  </div>
                </div>
                <div
                  class="col d-flex flex-row justify-content-end align-items-center"
                >
                  <action-button
                    class="outline-success mr-2"
                    text="Enviar"
                    i="fa fa-envelope"
                    @click="sendEmail(item)"
                  />
                  <br />
                  <action-button
                    class="outline-success mr-2"
                    text="Mostrar"
                    i="fa fa-eye"
                    @click="showItemReminder(item)"
                  />
                </div>
              </div>
            </div>
            <!-- <pagination
              v-if="
                results.data.length > 0 &&
                pagination.totalItemCount > pagination.pageSize
              "
              :show-text="true"
              @pagination-go-page="goToPageHandler"
              :data="pagination"
            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//components
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import SeparatorExtended from '../../components/common/SeparatorExtended.vue';
//services
//   import { getProfileInformation as _getProfileInformation } from '@/services/app.api.js';
import {
  getRoles as _getRoles,
  getRequestHideMThan6Month as _getRequest,
  sendNotification,
  hideItemReminder,
} from '@/services/app.api.js';
import { getUsers as _getUsers } from '@/services/auth.api.js';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'HideEmail',
  components: {
    //UserProfile,
    CustomInput,
    ActionButton,
    CustomDropDown,
    Pagination,
    CustomResultNotFound,
    SeparatorExtended,
  },
  mixins: [alertMixin],
  data: () => ({
    model: {
      searchUser: '',
      role: '',
      email: '',
      phone: '',
    },
    options: {
      roles: [],
    },
    results: {
      data: [],
    },
    //profileInfo: null,
  }),
  async mounted() {
    this.disposeCaseInfo();
    this.onLoadOptions();
  },
  methods: {
    async onLoadOptions() {
      this.options.roles = (await _getRoles()).data;
      // await this.onSearch();
      await this.getRequest();
    },
    async showItemReminder(item) {
      if (
        confirm(
          'Esta seguro que desea volver a mostrar esta solicitud como activa?'
        )
      ) {
        await hideItemReminder(item.itemId, false);
        await this.getRequest();
      }
    },
    async getRequest() {
      var result = (await _getRequest()).data;
      this.results.data = result;
      console.log(result);
    },
    async onSearch(page) {
      if (page == undefined) {
        page = 1;
      }
      this.results = (
        await _getUsers(
          this.model.searchUser,
          this.model.role.id,
          this.model.email,
          this.model.phone,
          page
        )
      ).data;
    },
    goToPageHandler(page) {
      this.onSearch(page);
    },
    sendEmail(item) {
      if (confirm('Esta Seguro que desea enviar este correo electronico')) {
        const data = [];

        data.push(item.itemId);
        console.log(data);
        sendNotification(data);
      }
    },

    async deleteUser(item) {
      const answer = await this.ShowCancelModal(
        'Eliminar Usuario',
        '¿Está seguro que desea eliminar el usuario?',
        'Si',
        'No'
      );
      if (answer) {
        this.ShowToast(
          'Proceso exitoso',
          'El usuario ha sido removido exitosamente.',
          'success'
        );
        this.onSearch(item);
      }
    },
  },
  computed: {
    emptyResults() {
      return this.results.length === 0;
    },
    pagination() {
      return {
        totalItemCount: this.results.totalItemCount,
        pageSize: 10,
        currentPage: this.results.currentPage,
        totalPages: this.results.pageCount,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';

.rb__extended ::v-deep {
  .col-12 {
    margin-left: -24px !important;
  }
}
</style>
